import { Types } from "../actions/salaryCalculatorActions";
import _ from "lodash";

const salaryCalculatorReducers = (state, action) => {
    switch (action.type) {
        case Types.CALCULATION_READY: {
            let newState = { ...state }

            newState.salaries = { ...newState.salaries }

            const cola = {
                earnings: action.cola?.earnings,
                deductions: action.cola?.deductions,
                net: action.cola?.net
            }
            newState.salaries.cola = cola

            newState.salaries.earnings = action.data.earnings
            newState.salaries.deductions = action.data.deductions
            newState.salaries.net = action.data.net
            return newState;
        }
        case Types.CALCULATION_REPORT_REQUESTED: {
            let newState = { ...state }
            switch (action.name) {
                case 'generateSamplePayslip':
                    newState.salaryCalculator = {
                        creating: true,
                        downloadLink: false,
                    }
                    break
                case 'GenerateColaReport':
                    newState.colaCalculator = {
                        creating: true,
                        downloadLink: false,
                    }
            }

            return newState;
        }
        case Types.CALCULATION_REPORT_SENT: {
            let newState = { ...state }
            switch (action.name) {
                case 'generateSamplePayslip':
                    newState.salaryCalculator = {
                        creating: false,
                        downloadLink: action.url,
                    }
                    break
                case 'GenerateColaReport':
                    newState.colaCalculator = {
                        creating: false,
                        downloadLink: action.url,
                    }
            }
            return newState;
        }
        case Types.CALCULATION_FILE_UPLOADING: {
            let newState = _.cloneDeep(state);

            newState.colaCalculator = {
                ...newState.colaCalculator,
                uploading: true
            };

            return newState;
        }
        case Types.CALCULATION_FILE_UPLOADED: {

            let newState = _.cloneDeep(state);

            newState.colaCalculator = {
                ...newState.colaCalculator,
                uploading: false,
                uploadResults: action.payload
            };

            return newState;
        }
        default:
            return state;
    }
}

export default salaryCalculatorReducers;